import { POWER_UPS, STAR_SECONDS, powerUpSeconds } from '@accra/shared';
import type { RunState } from '../../game/RunState';
import { el } from '../components/el';

/** Active power-ups (and a score star's boost) with a draining bar each. */
export class PowerChips {
  private readonly root = el('div', 'power-chips');
  private readonly chips = new Map<string, { chip: HTMLElement; fill: HTMLElement }>();
  private readonly star = el('div', 'power-chip star-chip');
  private readonly starLabel = el('span', 'power-icon star-factor');
  private readonly starFill = el('div', 'power-fill');

  constructor(parent: HTMLElement) {
    for (const p of POWER_UPS) {
      const chip = el('div', 'power-chip');
      const fill = el('div', 'power-fill');
      const bar = el('div', 'power-bar');
      bar.append(fill);
      chip.append(el('span', 'power-icon', p.icon), el('span', 'power-name', p.name), bar);
      this.chips.set(p.id, { chip, fill });
      this.root.append(chip);
    }
    const bar = el('div', 'power-bar');
    bar.append(this.starFill);
    this.star.append(this.starLabel, el('span', 'power-name', 'Score star'), bar);
    this.root.prepend(this.star);
    parent.append(this.root);
  }

  update(state: RunState): void {
    const starOn = state.star.left > 0;
    this.star.classList.toggle('show', starOn);
    if (starOn) {
      this.starLabel.textContent = `×${state.star.factor}`;
      this.starFill.style.width = `${(state.star.left / STAR_SECONDS) * 100}%`;
    }
    for (const p of POWER_UPS) {
      const entry = this.chips.get(p.id);
      if (!entry) continue;
      const left = state.powers[p.id];
      entry.chip.classList.toggle('show', left > 0);
      if (left > 0) entry.fill.style.width = `${(left / powerUpSeconds(p.id, state.upgrades[p.id])) * 100}%`;
    }
  }
}
